import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { BusinessWebsiteDomainAgeDetection } from 'dashboard/models/check';

export const computeBusinessWebsiteDomainAgeDetectionMetadata = (
  check: BusinessWebsiteDomainAgeDetection,
): CheckMetadata => {
  const createdAt = check.metadata?.['created-at'];
  const ageInDays = check.metadata?.['age-in-days'];
  const metadata = [
    {
      label: 'Created At',
      value: createdAt ? createdAt : '-',
    },
  ];

  if (ageInDays != null) {
    metadata.unshift({
      label: 'Domain Age',
      value: ageInDays ? formatDomainAge(ageInDays) : '-',
    });
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};

export const formatDomainAge = (ageInDays: number): string => {
  const years = Math.floor(ageInDays / 365);
  const months = Math.floor(ageInDays / 30);

  if (years > 0) {
    return `${years} year${years > 1 ? 's' : ''}`;
  } else if (months > 0) {
    return `${months} month${months > 1 ? 's' : ''}`;
  } else {
    return `${ageInDays} day${ageInDays > 1 ? 's' : ''}`;
  }
};
